import { atom } from 'jotai';

/**
 * Atom for storing the GUID of the lot selected for deletion
 */
export const selectedLotGuidForDeletionAtom = atom<string | null>(null);

/**
 * Atom for controlling the visibility of the lot deletion confirmation modal
 */
export const showLotDeletionConfirmModalAtom = atom<boolean>(false);

/**
 * Set only by catalog 3-dot delete. Edit-lot delete leaves it false so the shared
 * confirm modal does not run the featured-lot check on that path.
 */
export const catalogFeaturedDeleteCheckAtom = atom<boolean>(false);

/**
 * Atom for tracking lot form submission state
 */
export const isLotFormSubmittingAtom = atom<boolean>(false);

/**
 * Atom for storing the bid count of the lot selected for deletion
 */
export const selectedLotBidCountAtom = atom<number | undefined>(undefined);

/**
 * Atom holding the set of selected lot GUIDs (atgGlobalLotId UUIDs) for bulk actions
 * (edit + delete). Drives the table's selectedRows and the toolbar selection count. Plain
 * atom; selection resets on navigation (no persistence).
 */
export const selectedLotGuidsAtom = atom<Set<string>>(new Set<string>());

/**
 * Per-selected-lot deletability flags. Selection can span pages, so we record
 * `canDeleteLot(lot)` at select time (same pattern as `selectedLotHasBidsAtom`).
 * Used to enable the toolbar Delete control only when every selected lot is deletable —
 * lots with bids remain selectable for Edit, but not deletable.
 * Cleared whenever `selectedLotGuidsAtom` is cleared (page unmount / search reset).
 */
export const selectedLotCanDeleteAtom = atom<Readonly<Record<string, boolean>>>({});

/**
 * Atom controlling the bulk-lot-deletion confirmation modal:
 * null = closed, 'selected' = confirm deleting the selected lots, 'all' = confirm deleting all lots.
 */
export const showBulkLotDeletionConfirmModalAtom = atom<'selected' | 'all' | null>(null);

/**
 * Atom tracking whether a bulk lot deletion is in flight. Set by useDeleteBulkLots during the
 * mutation; read by LotTable to show the loading overlay.
 */
export const isBulkLotDeletingAtom = atom<boolean>(false);
